import state from '../state'

export default (node, parent, scope, file) => {
  // onImports
}